//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            show: 'intro',
            screensToShow: [
                {
                    name: 'surgeon',
                    shown: false
                },
                {
                    name: 'medtech',
                    shown: false
                },
                {
                    name: 'roboter',
                    shown: false
                }
            ]
        };
    },

    methods: {
        showScreen (screen) {
            screen.shown = true;
            this.show = screen.name;

            if (!this.screensToShow.filter(screen => !screen.shown).length) {
                this.showNext = true;
            }
        }
    }
};
